
  import { defineComponent } from 'vue';

  import constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import AggregatedPageWrapper from '../components/common/AggregatedPageWrapper.vue';
  import { TExportConfig } from '../components/common/ved-aggregated-export-buttons/types';
  import FTSWeeklyFilter from '../components/fts/fts-weekly/FTSWeeklyFilter.vue';
  import FTSWeeklyTable from '../components/fts/fts-weekly/FTSWeeklyTable.vue';
  import { CostTypes, WeightTypes } from '../types/common-aggregated';
  import { FTSTradeDirections } from '../types/fts-common';
  import { TFTSWeeklyFilterRequest } from '../types/fts-weekly';
  import { TAggregatedPermissions } from '../types/permission';
  import { getFilenameWithPeriod } from '../utils/filename';
  import { getNormalizedCountriesFilter } from '../utils/fts/countries';

  import links from '@/utils/links';

  const DEFAULT_FILTER: TFTSWeeklyFilterRequest = {
    codes: [],
    productsGroupsIds: [],
    productsTwoSignsIds: [],
    productsFourSignsIds: [],
    productsSixSignsIds: [],
    productsEightSignsIds: [],
    productsNineSignsIds: [],
    productsTenSignsIds: [],
    usersGroupsIds: [],
    isProductNumber: false,
    isProductDescription: false,
    isAdditionalProductDescription: false,
    statisticsCountryIds: [],
    originCountryIds: [],
    departureCountryIds: [],
    destinationCountryIds: [],
    senderOkatoIds: [],
    recipientOkatoIds: [],
    periods: [],
    finResponsibleOkatoIds: [],
    isCumulativeTotal: false,
    isAdditionalUnits: false,
    isCodeAdditionalUnits: false,
    firstGroupingId: undefined,
    secondGroupingId: undefined,
    isStatisticsPrice: true,
    isSumDollarsPayments: false,
    isPriceProduct: false,
    isWeightProduct: false,
    isQuotaProduct: false,
    weightId: WeightTypes.TONS,
    costInId: CostTypes.THOUSANDS_OF_DOLLARS,
    tradeDirectionId: FTSTradeDirections.EXPORT_IMPORT,
    isQuotaCurrencyDigitalCode: false,
    isQuotaCurrencyName: false,
    customsProcedureIds: [],
    deliveryTermsIds: [],
    transportTypesOnBorderIds: [],
    transportTypesInsideCountryIds: [],
    customsOrgansOnBorderIds: [],
    regionIds: [],
    deliveryGoodsPointIds: [],
    exporterIds: [],
    isProducer: false,
    isContainer: false,
    isCurrency: false,
  };

  export default defineComponent({
    name: 'FTSWeekly',
    components: {
      FTSWeeklyTable,
      FTSWeeklyFilter,
      AggregatedPageWrapper,
    },
    mixins: [security],
    data(): {
      defaultFilter: TFTSWeeklyFilterRequest;
      filter: TFTSWeeklyFilterRequest;
      filterForExport: TFTSWeeklyFilterRequest;
    } {
      return {
        defaultFilter: { ...DEFAULT_FILTER },
        filter: { ...DEFAULT_FILTER },
        filterForExport: { ...DEFAULT_FILTER },
      };
    },
    mounted() {
      this.checkPermissionAndRedirect(this.getPermissions.view);
    },
    computed: {
      getPermissions(): TAggregatedPermissions {
        return {
          view: constants.Permissions.ForeignTradeAnalyticsFtsWeekRequestView,
          build: constants.Permissions.ForeignTradeAnalyticsFtsWeekRequestBuild,
          export: constants.Permissions.ForeignTradeAnalyticsFtsWeekRequestDownload,
        };
      },

      getNormalizedFilters() {
        return {
          ...this.filter,
          ...getNormalizedCountriesFilter(this.filter),
        };
      },
      getNormalizedExportFilters() {
        return {
          ...this.filterForExport,
          ...getNormalizedCountriesFilter(this.filterForExport),
        };
      },
      getExportConfig(): TExportConfig {
        return {
          pdfFileName: this.getFileName(this.filter),
          excelFileName: this.getFileName(this.filterForExport),
          excel: {
            permissionCode: this.getPermissions.export,
            url: links.ved.fts.weekly.exportExcel,
            params: this.getNormalizedExportFilters,
          },
        };
      },
    },
    methods: {
      searchFilter(filter: TFTSWeeklyFilterRequest) {
        this.filter = filter;
      },
      updateFilter(filter: TFTSWeeklyFilterRequest) {
        this.filterForExport = filter;
      },
      getFileName(filter: TFTSWeeklyFilterRequest) {
        return getFilenameWithPeriod('Запрос_по_базе_ФТС_(неделя)', filter.periods);
      },
    },
  });
